import { getCurrentUser, waitForAuthReady } from '../global';
import { openBoundedWidget } from './bounded-login-widget';
let pendingSignIn = null;
/**
 * Return the restored user or open the Bounded sign-in widget when signed out.
 *
 * Calls made while init() is restoring a stored session wait for that work first.
 * Concurrent calls share one attempt, so repeated clicks cannot open competing
 * auth flows. If initialization fails, its original error is preserved.
 */
export function ensureSignedIn(options) {
    if (pendingSignIn)
        return pendingSignIn;
    const attempt = (async () => {
        await waitForAuthReady();
        // Read again after readiness in case an auth-state callback completed a
        // sign-in between the readiness promise settling and this continuation.
        const currentUser = getCurrentUser();
        if (currentUser)
            return currentUser;
        return openBoundedWidget(options);
    })();
    pendingSignIn = attempt;
    const clearPending = () => {
        if (pendingSignIn === attempt)
            pendingSignIn = null;
    };
    void attempt.then(clearPending, clearPending);
    return attempt;
}
